/* eslint-disable prettier/prettier */
import { useEffect, useReducer, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Container, Form } from 'react-bootstrap';
import { CountryDynamicFields } from './CountryDynamicFields';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import baseURL, { getAsync } from '../../../components/helper/axiosHelper';
import {
  GET_COUNTRY_LIST,
  GET_EMIRATES_LIST,
  POST_SET_GETSUITABLE_TIME_LIST,
  POST_SET_GETWORK_TYPE_LIST,
  POST_SET_PROFFESSSION_LIST,
  SET_COUNTRIES,
  SET_DATA,
  SET_EMIRATES,
  SET_GETSUITABLE_TIME_LIST,
  SET_GETWORK_TYPE_LIST,
  SET_PROFFESSSION_LIST,
  UPDATE_FORM_DATA,
  initialState,
  reducer,
} from '../../../features/FormReducers/GlobalFormFeatures';
import useFetchAndDispatch from '../../../hooks/useFetchAndDispatch/useFetchAndDispatch';
import Userbanner from '../../../components/elements/Userbanner';
import axios from 'axios';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { useSelector } from 'react-redux';
import { PageHitCountApi } from '../../../shared/Helper';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';

const VolunteerDetailEdit = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [epUserID, setEpUserID] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [countryCheck, setCountryCheck] = useState(0);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [landLine, setLandLine] = useState('');
  const [formField, setFormField] = useState({
    skills: '',
    //landline: landLine,
    weekDaysName: [],
  });
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = location.state || {};
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    reset,
  } = useForm();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setLandLine(value);
      // setFormField((prev) => ({
      //   ...prev,
      //   [name]: value,
      // }));
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initialValues = {
    countryID: state.data[0]?.countryID || '',
    professionID: state.data[0]?.professionID || '',
    emiratesID: state.data[0]?.emiratesID || '',
    workTypeID: state.data[0]?.workTypeID || '',
    suitableTimeID: state.data[0]?.suitableTimeID || '',
    // weekDaysName: state.data[0]?.weekDaysName || weekDaysSelect.value,
    // Add other fields as needed
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID != null) {
      PageHitCountApi(location.pathname, epUserID);
    }
  }, [epUserID]);

  // Set the default values for each field
  useEffect(() => {
    localStorage.setItem('isHome', false);
    Object.entries(initialValues).forEach(([fieldName, value]) => {
      setValue(fieldName, value);
    });
  }, [initialValues, setValue]);

  // Convert the ids to integers and submit the form data
  const onSubmit = (formData) => {
    // Destructure the formData object
    const { countryID, emiratesID, professionID, suitableTimeID, workTypeID } = formData;

    let headersList = {
      Accept: '*/*',
      id: id,
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    };
    const data = {
      epUserName: localStorage.getItem('userName'),
      weekDayId: '',
      date: new Date().toDateString(),
      timeNow: new Date().toTimeString(),
      volunteerRegID: Number(state?.data[0]?.volunteerRegID),
      epUserID: id,
      pageCount: 1,
      countryID: Number(countryID),
      emiratesID: Number(emiratesID) || 0,
      landLine: landLine || state.data[0]?.landLine,
      professionID: Number(professionID),
      skills: formData.skills || state.data[0]?.skills,
      suitableTimeID: Number(suitableTimeID),
      weekDaysName: formField.weekDaysName,
      workTypeID: Number(workTypeID),
    };

    if (data) {
      setIsLoad(true);
      axios
        .put(UPDATE_FORM_DATA, data, { id: id, headers: headersList })
        .then((response) => {
          if (response) {
            setIsLoad(false);
            toast.success(t('Updated Successfully'));
            navigate('/volunteerlist');
          }
        })
        .catch((error) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    } else {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  // Use the custom hook for each API call
  useFetchAndDispatch('GET', GET_COUNTRY_LIST, SET_COUNTRIES, dispatch);
  useFetchAndDispatch('GET', GET_EMIRATES_LIST, SET_EMIRATES, dispatch);
  useFetchAndDispatch('POST', POST_SET_PROFFESSSION_LIST, SET_PROFFESSSION_LIST, dispatch);
  useFetchAndDispatch('POST', POST_SET_GETSUITABLE_TIME_LIST, SET_GETSUITABLE_TIME_LIST, dispatch);
  useFetchAndDispatch('POST', POST_SET_GETWORK_TYPE_LIST, SET_GETWORK_TYPE_LIST, dispatch);

  const weekDaysSelect = {
    id: 9,
    label: 'Week Day',
    type: 'checkbox',
    validation: { required: true },
    name: 'weekDaysName',
    placeholder: 'Week Day',
    options: [
      { label: 'Sunday', value: 1 },
      { label: 'Monday', value: 2 },
      { label: 'Tuesday', value: 3 },
      { label: 'Wednesday', value: 4 },
      { label: 'Thursday', value: 5 },
      { label: 'Friday', value: 6 },
      { label: 'Saturday', value: 7 },
    ],
    value: [],
    disabled: true,
  };

  const onChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormField((prev) => {
      if (type === 'checkbox') {
        const intValue = parseInt(value, 10);

        if (!isNaN(intValue)) {
          const updatedState = checked ? [...prev[name], intValue] : prev[name].filter((day) => day !== intValue);

          return {
            ...prev,
            [name]: updatedState.length > 0 ? updatedState : [],
          };
        }
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }

      return prev; // Default case, if no changes are made
    });
  };
  useEffect(() => {
    localStorage.setItem('isHome', false);
    getEPUserData();
  }, []);

  const getEPUserData = async () => {
    setIsLoad(true);
    await getAsync('EP_UserAuthentication/EPUserByID/', {
      id: id,
    })
      .then((response) => {
        setIsLoad(false);
        if (response != null) {
          const result = response?.data[0];
          setFullName(result?.fullName);
          setMobile(result.mobile);
          setEmail(result.email);
        } else {
          toast.error(`${t('Record Not Found.')}`);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    (async () => {
      let headersList = {
        Accept: '*/*',
        id: id,
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      };
      await axios
        .get(`${baseURL}/Volunteer/GetEPVolunteerRegByEpUserId`, { headers: headersList })
        .then((response) => {
          const result = response?.data?.data;
          setCountryCheck(result[0]?.countryID);
          setLandLine(result[0]?.landLine);
          setFormField({
            //landLine: result[0]?.landLine,
            skills: result[0]?.skills,
            weekDaysName: result[0]?.weekDaysName,
          });
          dispatch({ type: SET_DATA, payload: result });
        })
        .catch((error) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    })();
  }, [id, t]);

  return (
    <div className="pt-12 ">
      <Userbanner />
      {isLoad ? (
        <LoadingAnimation imageStyling={''} styling={'flex items-center py-5 align-middle justify-center space-x-2'} />
      ) : (
        <Container className="py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
                {t('Volunteer Details Edit')}
              </h1>

              <div className="col-md-6 col-lg-4">
                <div className="form-group ">
                  <label className="my-2">{t('Full Name')}</label>
                  <input
                    type="text"
                    value={fullName}
                    disabled
                    style={{
                      cursor: 'no-drop',
                    }}
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="form-group">
                  <label className="my-2">{t('Mobile Number')}</label>
                  <input
                    type="text"
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                    disabled
                    value={mobile}
                    style={{
                      cursor: 'no-drop',
                    }}
                  />
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="form-group">
                  <label className="my-2">{t('Email')}</label>
                  <input
                    type="text"
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                    disabled
                    value={email}
                    style={{
                      cursor: 'no-drop',
                    }}
                  />
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div controlId="skills">
                  <label className="my-2">{t('Skill')}</label>
                  <input
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                    type="text"
                    name="skills"
                    placeholder={t('Skill')}
                    {...register('skills')}
                    //defaultValue={formField.skills}
                    value={formField.skills}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div controlId="landLine">
                  <label className="my-2">{t('Land Line')}</label>
                  <input
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                    type="text"
                    placeholder={t('Land Line')}
                    value={landLine}
                    //name="landline"
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div controlId="professionID">
                  <label className="my-2">{t('Profession')}</label>
                  <select
                    className=" w-full border py-2 border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                    as="select"
                    {...register('professionID', { defaultValue: state.data[0]?.professionID })}
                  >
                    {state?.professionList?.map((profession) => (
                      <option
                        key={profession?.professionID}
                        value={profession?.professionID}
                        defaultValue={profession?.professionID === state?.data[0]?.professionID}
                      >
                        {isActive ? profession?.ar_Sa : profession?.en_Us}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <CountryDynamicFields
                state={state}
                countryCheck={countryCheck}
                register={register}
                getValues={getValues}
              />

              <div className="col-md-6 col-lg-4 ">
                <div controlId="suitableTimeID">
                  <label className="my-2">{t('Suitable Time')}</label>
                  <Form.Control
                    className=" w-full border py-2 border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                    as="select"
                    {...register('suitableTimeID')}
                  >
                    {state?.getSuitableTimeList?.map((suitableTime) => (
                      <option key={suitableTime?.suitableTimeID} value={suitableTime?.suitableTimeID}>
                        {t(suitableTime?.en_Us)}
                      </option>
                    ))}
                  </Form.Control>
                  {errors.suitableTimeID && (
                    <Form.Text className="text-muted">{t('This field is required.')}</Form.Text>
                  )}
                </div>
              </div>
            </div>

            <div className="row  my-2">
              <div className=" md:flex flex justify-center">
                <div className="md:col  justify-center items-start gap-2" controlId="weekDaysName">
                  <div className="flex justify-center">
                    <label className="my-2 text-2xl font-black">{t('Week Days')}</label>
                  </div>

                  <div className=" flex flex-wrap md:flex-row px-2 gap-2 justify-center">
                    {weekDaysSelect.options.map(
                      (option) =>
                        // <Form.Check
                        //   className="   flex-row ml-5 p-1  my-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium text-sm"
                        //   key={option.value}
                        //   type={weekDaysSelect.type}
                        //   label={`${t(option.label)}`}
                        //   value={option.value}
                        //   name={weekDaysSelect.name}
                        //   {...register('weekDaysName')}
                        //   checked={formField.weekDaysName?.includes(option.value)}
                        //   onChange={onChange}
                        // />

                        // new code for check box

                        isActive ? (
                          <>
                            <div className="my-2 gap-2">
                              <input
                                className=" "
                                option={option}
                                id={`check-api-${option.value}`}
                                value={option.value}
                                name={weekDaysSelect.name}
                                {...register('weekDaysName')}
                                checked={formField.weekDaysName?.includes(option.value)}
                                onChange={onChange}
                                type={weekDaysSelect.type}
                                type="checkbox"
                                className="peer relative h-5 w-5 cursor-pointer focus:ring-4 focus:ring-customgreen appearance-none rounded-md border border-customgreen transition-all
      before:content[''] before:absolute before:top-2/4 before:left-2/4 before:block before:h-5 before:w-5 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-customgreen before:opacity-0 before:transition-opacity
      checked:border-none checked:bg-customgreen checked:before:bg-white hover:before:opacity-10"
                                id="check"
                              />
                              <label className={` mr-3 font-bold`}>{`${t(option.label)}`}</label>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="my-2 gap-2">
                              <input
                                className="mx-2 "
                                option={option}
                                id={`check-api-${option.value}`}
                                value={option.value}
                                name={weekDaysSelect.name}
                                {...register('weekDaysName')}
                                checked={formField.weekDaysName?.includes(option.value)}
                                onChange={onChange}
                                type={weekDaysSelect.type}
                                type="checkbox"
                                className="peer relative h-5 w-5 cursor-pointer focus:ring-4 focus:ring-customgreen appearance-none rounded-md border border-customgreen transition-all
      before:content[''] before:absolute before:top-2/4 before:left-2/4 before:block before:h-5 before:w-5 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-customgreen before:opacity-0 before:transition-opacity
      checked:border-none checked:bg-customgreen checked:before:bg-white hover:before:opacity-10"
                                id="check"
                              />
                              <label className={` ml-3  font-bold`}>{`${t(option.label)}`}</label>
                            </div>
                          </>
                        ),

                      // new code for check box
                    )}
                  </div>
                  {errors.weekDaysName && <Form.Text className="text-muted">{t('This field is required.')}</Form.Text>}
                </div>
              </div>
              <div className="px-3 my-2 gap-2 flex justify-center">
                <button
                  type="submit"
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                >
                  {' '}
                  {t('Update')}
                </button>
                <Link
                  to="/volunteerlist"
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                >
                  {' '}
                  {t('Back')}
                </Link>
              </div>
            </div>
          </form>
        </Container>
      )}
    </div>
  );
};

export default VolunteerDetailEdit;
